export const PAY_METHOD_OPTIONS = {
  'card': 'прикреплённая карта',
  'link': 'платёжная ссылка',
};

export const PAY_METHOD_OPTIONS_MAP = {
  card: [ 'card', 'link' ]
}
